import type { TaskSyncStatus } from "../../domain/app-types.ts";
import type { Todo } from "../../domain/entities.ts";
import type { SyncState } from "../../infrastructure/sync/automerge.ts";
import { updateSubtaskProgressView, updateSyncPillView, updateTaskSyncViews } from "./presentation.ts";

export interface SyncPresentationRuntimeCapabilities {
  document: Document;
  state(): SyncState;
  label(): string;
  tasks(): Todo[];
  setTasks(tasks: Todo[]): void;
  statuses(): Map<string, TaskSyncStatus>;
  renderBadge(id: string): string;
}

export function createSyncPresentationRuntime(capabilities: SyncPresentationRuntimeCapabilities) {
  function updateState(): void {
    updateSyncPillView(capabilities.document, capabilities.state(), capabilities.label());
  }

  function update(): void {
    updateState();
    updateTaskSyncViews(capabilities.document, capabilities.statuses(), capabilities.renderBadge);
  }

  function updateSubtask(todo: Todo, subtaskId: string, trigger: HTMLElement): void {
    capabilities.setTasks(capabilities.tasks().map(item => item.id === todo.id ? todo : item));
    capabilities.statuses().set(todo.id, "local");
    updateSubtaskProgressView(capabilities.document, todo, subtaskId, trigger);
    update();
  }

  return { updateState, update, updateSubtask };
}
